/**
 * BlocPièce — vignette du fichier attaché à la fiche (zone [4bis]).
 *
 * Reprise telle quelle de l'aperçu ⌘K, absorbé dans le contrat `SummaryDetail`
 * le 2026-08-11 :
 *   • image → `<img>` ;
 *   • PDF   → `<iframe>` figé sur la 1ʳᵉ page (`#toolbar=0`), NON interactif
 *     (`pointer-events-none` + `tabIndex={-1}`) : c'est une vignette, pas un
 *     lecteur — la lecture scrollable reste le « coup d'œil » plein écran.
 *
 * Le backend n'envoie d'URL que pour les formats qui ont un rendu inline ; un
 * .docx n'en a pas, et ce bloc disparaît plutôt que de peindre un cadre vide.
 */

import type { SummaryDocument } from '../types'

export function SummaryDocumentBlock({ document, label }: { document: SummaryDocument; label: string }) {
    if (document.thumbnail_url) {
        return (
            <img
                src={document.thumbnail_url}
                alt=""
                className="max-h-44 w-full rounded-md border border-border object-contain"
            />
        )
    }
    if (document.mime === 'application/pdf' && document.preview_url) {
        return (
            <div className="overflow-hidden rounded-md border border-border bg-muted/30">
                <iframe
                    src={`${document.preview_url}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                    title={label}
                    tabIndex={-1}
                    className="pointer-events-none h-48 w-full border-0"
                />
            </div>
        )
    }
    return null
}
